import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoFileMastersGetRes } from "./abst/DtoFileMastersGetRes";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoFileMastersGetResImple extends DtoFileMastersGetRes {


}
